/* eslint-disable @fx-ui/jdy-design/no-blacklist-constant */

/**
 * 外部URL地址
 * 注意简道云的相关固定URL也属于外部URL(非站内)
 */
export const EXTERNAL_URL = {
    /**
     * clarity
     * @see FXD-60337
     */
    CLARITY: 'https://www.clarity.ms/tag/',
    // 微信登录js
    WECHAT_LOGIN_SCRIPT: 'https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js',
    // 微信二维码地址
    // @see https://developers.weixin.qq.com/doc/offiaccount/Account_Management/Generating_a_Parametric_QR_Code.html
    WECHAT_QR_CODE: 'https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=',
    // jodoo 人机验证
    CLOUDFLARE_TURNSTILE_URL: 'https://challenges.cloudflare.com/turnstile/v0/api.js'
};
